import {
  ALL_ADMIN_WEB_ROLES,
  BANTUAN_ROLES,
  COMMUNICATION_ROLES,
  CONTENT_ROLES,
  DANA_BANTUAN_ROLES,
  DASHBOARD_ROLES,
  FINANCE_ROLES,
  KEMITRAAN_ROLES,
  SECRETARIAT_ROLES,
  canAccess,
} from "@/utils/permissions";

// Menu sidebar — juga dipakai Manual Penggunaan untuk menampilkan menu
// yang bisa diakses peran aktif.
export interface NavItem {
  name: string;
  label: string;
  to: string;
  icon: string;
  roles?: string[];
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Utama",
    items: [
      { name: "Dashboard", label: "Dashboard", to: "/dashboard", icon: "dashboard", roles: DASHBOARD_ROLES },
      { name: "Manual Penggunaan", label: "Manual Penggunaan", to: "/manual", icon: "bookCheck", roles: ALL_ADMIN_WEB_ROLES },
    ],
  },
  {
    label: "Formulir & Layanan",
    items: [
      { name: "Pengajuan Bantuan", label: "Pengajuan Bantuan", to: "/pengajuan-bantuan", icon: "fileHeart", roles: BANTUAN_ROLES },
      { name: "Pendataan Anggota", label: "Pendataan Anggota", to: "/pendataan-anggota", icon: "userCheck", roles: SECRETARIAT_ROLES },
      { name: "Orangtua Asuh", label: "Orangtua Asuh", to: "/orangtua-asuh", icon: "shieldHeart", roles: BANTUAN_ROLES },
      { name: "Dana Bantuan", label: "Dana Bantuan", to: "/dana-bantuan", icon: "piggyBank", roles: DANA_BANTUAN_ROLES },
    ],
  },
  {
    label: "Donasi & Pembayaran",
    items: [
      { name: "Dashboard Pembayaran", label: "Dashboard Pembayaran", to: "/dashboard-pembayaran", icon: "paymentChart", roles: FINANCE_ROLES },
      { name: "Donasi", label: "Donasi", to: "/donasi", icon: "handCoins", roles: FINANCE_ROLES },
      { name: "Fakultas", label: "Fakultas", to: "/fakultas", icon: "school", roles: FINANCE_ROLES },
    ],
  },
  {
    label: "Komunikasi",
    items: [
      { name: "Broadcast", label: "Broadcast Pesan", to: "/broadcast", icon: "mail", roles: COMMUNICATION_ROLES },
      { name: "Template Pesan", label: "Template Pesan", to: "/template-pesan", icon: "chatMessage", roles: COMMUNICATION_ROLES },
    ],
  },
  {
    label: "Konten",
    items: [
      { name: "Kegiatan", label: "Kegiatan", to: "/kegiatan", icon: "calendarCheck", roles: CONTENT_ROLES },
    ],
  },
  {
    label: "Katalog & Transaksi",
    items: [
      { name: "Merchandise", label: "Merchandise", to: "/merchandise", icon: "shirt", roles: FINANCE_ROLES },
      { name: "Merchandise Dashboard", label: "Dashboard Merchandise", to: "/merchandise-dashboard", icon: "packageChart", roles: FINANCE_ROLES },
      { name: "Transactions", label: "Transaksi Merchandise", to: "/transactions", icon: "receiptText", roles: FINANCE_ROLES },
    ],
  },
  {
    label: "Kemitraan",
    items: [
      { name: "Kemitraan", label: "Kemitraan", to: "/kemitraan", icon: "handshake", roles: KEMITRAAN_ROLES },
      { name: "Kegiatan Kemitraan", label: "Kegiatan Kemitraan", to: "/kegiatan-kemitraan", icon: "calendarHandshake", roles: KEMITRAAN_ROLES },
    ],
  },
];

export const navGroupsForRole = (roleId?: string | null): NavGroup[] =>
  NAV_GROUPS
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => canAccess(item.roles, roleId)),
    }))
    .filter((group) => group.items.length > 0);
